export default "__VITE_PUBLIC_ASSET__47444681__"